import { ChevronLeft } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import Box from "@mui/material/Box";
import { Button } from "@components/ui/button";
import SimpleBar from "simplebar-react";
import { Textarea } from "@components/ui/textarea";
import { SubmitHandler, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import "simplebar-react/dist/simplebar.min.css";
import { addBmaProfile, VpsProfile } from "@redux/slices/strategicPlanning";
import useAuth from "@hooks/useAuth";
import LoadingScreen from "@components/LoadingScreen";
import { Input } from "@components/ui/input";
import { addNotification } from "@redux/slices/notifications";
import { enqueueSnackbar } from "notistack";
import NotifyMessage from "./notify";

const AddBma: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const [formData, setFormData] = useState<VpsProfile>({
    user_id: user?.id,
    user_name: user?.first_name + " " + user?.last_name,
    status: "",
    name: "",
    question1: "",
    question2: "",
    question3: "",
    question4: "",
    question5: "",
    question6: "",
    question7: "",
    question8: "",
    question9: "",
    question10: "",
  });

  const icpSchema = z.object({
    question1: z.string(),
    name: z.string(),
    question2: z.string(),
    question3: z.string(),
    question4: z.string(),
    question5: z.string(),
    question6: z.string(),

    question7: z.string(),
    question8: z.string(),
    question9: z.string(),
    question10: z.string(),
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [Notify, setNotify] = useState(false);

  type ICPFormData = z.infer<typeof icpSchema>;

  // Initialize React Hook Form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ICPFormData>({
    resolver: zodResolver(icpSchema),
    mode: "onBlur",
  });

  const onSubmit: SubmitHandler<ICPFormData> = (data) => {
   
    addProfile();
  };
  const addProfile = async () => {
    try {
      setLoading(true);

      let updatedFormData = { ...formData };
      if (
        formData?.name != "" &&
        formData?.question1 != "" &&
        formData.question2 != "" &&
        formData.question3 != "" &&
        formData.question4 != "" &&
        formData.question5 != "" &&
        formData.question6 != "" &&
        formData.question7 != "" &&
        formData.question8 != "" &&
        formData.question9 != "" &&
        formData.question10 != ""
      ) {
        console.log("first");
        updatedFormData = {
          ...updatedFormData,
          status: "completed",
        };
        await addNotification("Bma Added", `${user?.email} added bma `);
      } else {
        updatedFormData = {
          ...updatedFormData,
          status: "draft",
        };
      }

      await addBmaProfile(updatedFormData, "Profile added successfully");

      setLoading(false);
      navigate(`/strategicPlanning/bma/${user?.id}`);
    } catch (error) {
      console.error("Error in addProfile:", error);
      setLoading(false);
    }
  };

  const handleButton1Click = () => {
    console.log("fun")
    onSubmit(formData);
    if(Notify){
      setNotify(false)
    }
    else{
      setNotify(true)
    }
  };

  const handleButton2Click = () => {
    
    if(Notify){
      setNotify(false)
    }
    else{
      setNotify(true)
    }
  };

  const validation =()=>{

    const isAnyFieldEmpty = Object.values(formData).some(
      (value) => value === ""
    );

    if(isAnyFieldEmpty || formData.name){
       setNotify(true)
    }
    else {
       onSubmit(formData);
    }
  }

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          {Notify && 

          <NotifyMessage
            message="This will be Template as fields are incomplete"
            onButton1Click={handleButton1Click}
            onButton2Click={handleButton2Click}
          />
           } 

          {/* Header */}
          <div className="flex justify-between items-center mb-5">
            <h4 className="text-xl font-bold flex items-center -ms-2">
              <ChevronLeft
                size={22}
                className="me-3 cursor-pointer"
                onClick={() => navigate(-1)}
              />
              Add Business Model and Market Analysis (BMA)
            </h4>
            <div className="flex items-start">
              <p className="mt-2">Profile Name: </p>
              <div>
                <Input
                  {...register("name")}
                  className="w-full ms-2"
                  placeholder="Profile Name"
                  value={formData?.name}
                  onChange={handleInputChange}
                  // value={}
                />
                {errors.name && (
                  <p className="text-red-500 text-sm ms-2 mt-1">
                    {errors.name.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Form Container */}
          <div className="px-56 mt-10">
            <Box sx={{ width: "100%" }}>
              <SimpleBar style={{ maxHeight: 450 }}>
                <div className="px-5">
                  {/* Question 1 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      1. What is the current pricing structure of your
                      product/service, and how do you justify this price?
                    </p>
                    <Textarea
                      {...register("question1")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question1}
                      onChange={handleInputChange}
                      // value={}
                    />
                    {errors.question1 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question1.message}
                      </p>
                    )}
                  </div>
                  {/* Question 2 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      2. What different pricing strategies have you tested, and
                      which were the most successful?
                    </p>
                    <Textarea
                      {...register("question2")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question2}
                      onChange={handleInputChange}
                    />
                    {errors.question2 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question2.message}
                      </p>
                    )}
                  </div>
                  {/* Question 3 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      3. How do you measure the Return on Investment (ROI) for
                      your customers?
                    </p>
                    <Textarea
                      {...register("question3")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question3}
                      onChange={handleInputChange}
                    />
                    {errors.question3 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question3.message}
                      </p>
                    )}
                  </div>
                  {/* Question 4 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      4. What additional services or products do you offer to
                      increase value for your customers?
                    </p>
                    <Textarea
                      {...register("question4")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question4}
                      onChange={handleInputChange}
                    />
                    {errors.question4 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question4.message}
                      </p>
                    )}
                  </div>
                  {/* Question 5 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      5. What market trends and innovations do you observe in
                      your industry that could affect your business model?
                    </p>
                    <Textarea
                      {...register("question5")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question5}
                      onChange={handleInputChange}
                    />
                    {errors.question5 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question5.message}
                      </p>
                    )}
                  </div>
                  {/* Question 6 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      6. How do your competitors respond to these trends and
                      innovations?
                    </p>
                    <Textarea
                      {...register("question6")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question6}
                      onChange={handleInputChange}
                    />
                    {errors.question6 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question6.message}
                      </p>
                    )}
                  </div>
                  {/* Question 7 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      7. What new market opportunities do you see in the next
                      2-5 years?
                    </p>
                    <Textarea
                      {...register("question7")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question7}
                      onChange={handleInputChange}
                    />
                    {errors.question7 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question7.message}
                      </p>
                    )}
                  </div>
                  {/* Question 8 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      8. How do you plan to respond to these market
                      opportunities?
                    </p>
                    <Textarea
                      {...register("question8")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question8}
                      onChange={handleInputChange}
                    />
                    {errors.question8 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question8.message}
                      </p>
                    )}
                  </div>
                  {/* Question 9 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      9. What technologies or developments could disrupt your
                      business model in the future?
                    </p>
                    <Textarea
                      {...register("question9")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question9}
                      onChange={handleInputChange}
                    />
                    {errors.question9 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question9.message}
                      </p>
                    )}
                  </div>
                  {/* Question 10 */}
                  <div className="mb-4">
                    <p className="text-[#71717A] mb-2">
                      10. How do you adapt your business model to remain
                      competitive and respond to market changes?
                    </p>
                    <Textarea
                      {...register("question10")}
                      className="h-24 w-full"
                      placeholder="Your answer..."
                      value={formData?.question10}
                      onChange={handleInputChange}
                    />
                    {errors.question10 && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.question10.message}
                      </p>
                    )}
                  </div>
                </div>
              </SimpleBar>
              <div className="flex justify-end mt-5 ">
                <Button className="bg-[#1CB5AF]" onClick={handleSubmit(validation)}>Save</Button>
              </div>
            </Box>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddBma;
